"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var react_1 = __importStar(require("react"));
var styles_1 = require("./styles");
var useScrollToSingleSelect_1 = __importDefault(require("./useScrollToSingleSelect"));
exports.NoOptionsInfo = function (_a) {
    var input = _a.input;
    return (react_1.default.createElement(core_1.ListItem, null,
        react_1.default.createElement(core_1.ListItemText, { primary: "no result matched " + input })));
};
exports.SingleSelect = react_1.forwardRef(function (_a, ref) {
    var option = _a.option, isSelected = _a.isSelected, clickFn = _a.clickFn;
    return (react_1.default.createElement(core_1.ListItem, { ref: ref, selected: isSelected, onClick: clickFn, button: true },
        react_1.default.createElement(core_1.ListItemText, { primary: option.text })));
});
exports.Selects = function (_a) {
    var filterInput = _a.filterInput, filteredOptions = _a.filteredOptions, selectedIndex = _a.selectedIndex, filterFn = _a.filterFn, selectFn = _a.selectFn, closeSelectsFn = _a.closeSelectsFn;
    var listRefs = react_1.default.useRef(filteredOptions.map(function (op) { return (react_1.default.createRef()); }));
    var classes = styles_1.useStylesSelectsInFilter();
    var handleSelectRoute = react_1.useCallback(function (index) {
        return function () {
            if (selectFn) {
                selectFn(index);
            }
        };
    }, [selectFn]);
    var handleClose = react_1.useCallback(function () {
        if (closeSelectsFn) {
            closeSelectsFn();
        }
    }, [closeSelectsFn]);
    useScrollToSingleSelect_1.default(listRefs, selectedIndex);
    return (react_1.default.createElement(core_1.Box, { className: classes && classes.root },
        react_1.default.createElement(core_1.Paper, null,
            react_1.default.createElement(core_1.Box, { padding: 1 },
                react_1.default.createElement(core_1.TextField, { fullWidth: true, autoFocus: true, variant: 'outlined', onChange: filterFn, value: filterInput })),
            react_1.default.createElement(core_1.List, { className: classes.selects }, filteredOptions.length > 0 ? (filteredOptions.map(function (option, i) { return (react_1.default.createElement(exports.SingleSelect, { key: i, ref: listRefs.current[i], option: option, isSelected: selectedIndex === i, clickFn: handleSelectRoute(i) })); })) : (react_1.default.createElement(exports.NoOptionsInfo, { input: filterInput })))),
        react_1.default.createElement(core_1.Box, { id: 'selectsInFilterBG', className: classes.clickBG, onClick: handleClose })));
};
exports.default = react_1.memo(exports.Selects);
